module.exports = __webpack_public_path__ + "static/media/Billing Icon.1291dedb.svg";